import { render } from "./yidongxunjian.vue?vue&type=template&id=b1b7e098&scoped=true&ts=true"
import script from "./yidongxunjian.vue?vue&type=script&lang=ts"
export * from "./yidongxunjian.vue?vue&type=script&lang=ts"

import "./yidongxunjian.vue?vue&type=style&index=0&id=b1b7e098&lang=scss&scoped=true"

import exportComponent from "D:\\ct-construction-ts-mobile\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b1b7e098"]])

export default __exports__